import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { useDispatch } from 'react-redux';
import { deleteCalendarAttendance } from '../../../redux/features/CRDslice';

const AttendanceDelete = ({ row, loading, setChange, setOpen,subject_enrollment_id }) => {
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();
  const handleDelete=()=>{
    dispatch(deleteCalendarAttendance({...row,subject_enrollment_id}))
      .then((res) =>
        apiHelper(res, {
          onSuccess: () => {
            setChange((p) => !p);
            setOpen(false);
          },
        }),
      );
  }
  return (
    <Stack gap={2}>
      <Typography variant="h6">Are you sure you want to delete this attendance?</Typography>
      <Typography variant="body2">This action cannot be undone.</Typography>
      <Stack direction="row" justifyContent="flex-end" gap={2}>
        <Button variant="outlined" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </Stack>
    </Stack>
  );
};

export default AttendanceDelete;
